import React from 'react';
import { Icon } from 'antd';
import './photoImage.css';

export const PhotoImage = ({imageURL}) => <img alt="User" className="photo" src={imageURL}/>;
export const PhotoPlaceholder = () => (
  <div className="placeholder-wrapper">
    <Icon type="user" className="photo-placeholder" />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/common/photoImage/photoImage.js